import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import SEO from "./common/SEO";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO title="404 - Pagina non trovata" description="La pagina cercata non è stata trovata sul sito della Nuova Orchestra da Camera Ferruccio Busoni." />
      <section className="section">
        <div className="container notfound">
          <div className="p-4 hide-on-mobile">
            <FontAwesomeIcon icon={faExclamationTriangle} size="8x" color="#ffae19" />
          </div>
          <div className="font1and2rem text-center text-md-left">
            <div>{t("notfound.description")}</div>
            <div className="mt-3">
              {t("notfound.goto")}{" "}
              <Link to="/" className="btn btn-outline-warning ms-2">
                {t("notfound.homepage")}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
